import React from 'react';
import BaseList from '@its/components/lib/Container components/ListContainer/BaseList';
import { getTimers } from '../../api';
import { onSuccess } from './util';
import {
  UserPermissionContainer,
} from '@its/components/lib/Container components/UserContainer/UserPermissionContainer';
import {
  developer,
  admin,
  config,
} from '@its/components/lib/Container components/UserContainer/roles';

export default class extends React.Component {

  static propTypes = {
    navigate: React.PropTypes.bool,
    buttonStyle: React.PropTypes.object,
  }

  static defaultProps = {
    navigate: true,
    buttonStyle: {},
  }

  constructor(props, context) {
    super(props, context);
    this.mapStateToProps = (state) => ({
      title: state.app.timers.list.title,
      columns: state.app.timers.list.columns,
      items: state.app.timers.list.items,
    });

    this.appBar = {
      title: 'TIMERS',
      navigateBack: false,
    };
  }

  render() {
    return (
      <UserPermissionContainer
        allowedRoles={[developer, admin, config]}
        showError
      >
        <BaseList
          mapStateToProps={this.mapStateToProps}
          route="timer/add"
          appBar={this.appBar}
          request={getTimers}
          onResult={onSuccess}
          buttonStyle={this.props.buttonStyle}
          navigate={this.props.navigate}
        />
      </UserPermissionContainer>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Timer/TimerList.js
 **/